import h from 'hyperscript';
import { generateIcon } from 'components/_particles/icon/icon';

const componentStore = [];

class NumberInput {
  constructor($el) {
    this.$el = $el;
    this.$input = this.$el.cloneNode();

    this.$input.addEventListener('change', this.handleOnInputChange);

    this.buildNumberInput();
  }

  buildNumberInput = () => {
    this.$countUp = h(
      'button.number-input__icon-button',
      {
        type: 'button',
        onclick: this.handleOnUp,
      },
      generateIcon({ icon: 'arrow-up', className: 'number-input__icon' }),
    );

    this.$countDown = h(
      'button.number-input__icon-button',
      {
        type: 'button',
        onclick: this.handleOnDown,
        disabled: this.$input.value <= 1,
      },
      generateIcon({ icon: 'arrow-down', className: 'number-input__icon' }),
    );

    const $wrapper = h('div.number-input__wrapper', this.$countUp, this.$input, this.$countDown);

    this.$el.parentElement.replaceChild($wrapper, this.$el);
  };

  handleOnInputChange = (event) => {
    const value = event.value || event.target.value;
    const min = Number(this.$input.getAttribute('min') || 1);
    const getMax = this.$input.getAttribute('max');

    this.$countDown.disabled = value <= min;

    if (getMax) {
      const max = Number(getMax);
      this.$countUp.disabled = value >= max;
    }
  };

  changeInputValue = (value) => {
    this.$input.value = value;
    const event = new CustomEvent('change', { value });

    this.$input.dispatchEvent(event);
  };

  handleOnUp = () => {
    const newValue = Number(this.$input.value) + 1;

    this.changeInputValue(newValue);
  };

  handleOnDown = () => {
    const newValue = Number(this.$input.value) - 1;

    this.changeInputValue(newValue);
  };
}

document.querySelectorAll('.number-input').forEach(($input) => {
  componentStore.push(new NumberInput($input));
});
